if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.loadLazyMedia();
      this.showActiveMedia();
    }

    // Full-size gallery images are stored in <template> tags inside
    // .product-media-modal__lazy-image wrappers so they are not present as
    // real <img> elements (and are not fetched by the browser) until the
    // media modal is actually opened. Populate them once, the first time
    // the modal is shown.
    loadLazyMedia() {
      if (this.mediaLoaded) return;
      this.mediaLoaded = true;
      this.querySelectorAll('.product-media-modal__lazy-image').forEach((wrapper) => {
        const lazyTemplate = wrapper.querySelector('template');
        if (lazyTemplate) {
          wrapper.appendChild(lazyTemplate.content.cloneNode(true));
          lazyTemplate.remove();
        }
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      const widthSource = activeMedia.classList.contains('product-media-modal__lazy-image')
        ? activeMedia.querySelector('img') || activeMedia
        : activeMedia;
      container.scrollLeft = (widthSource.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}
